/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_Order_ReturnedInputs */

const vi_status_order_returned = /** @type {(inputs: Status_Order_ReturnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã hoàn trả`)
};

/**

* @param {Status_Order_ReturnedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const status_order_returned = /** @type {((inputs?: Status_Order_ReturnedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_Order_ReturnedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_status_order_returned(inputs)
});